export const STACKED_FORM_CONTROL_CLASS = "MuiFormControl-stacked"

export type FormFieldVariant = "stacked" | "outlined" | "filled" | "standard"

export const getStackedFormControlClassName = (
  variant?: FormFieldVariant,
  className?: string
): string | undefined => {
  if (variant !== "stacked") {
    return className
  }

  return [STACKED_FORM_CONTROL_CLASS, className].filter(Boolean).join(" ")
}

export const getMuiTextFieldVariant = (
  variant?: FormFieldVariant
): Exclude<FormFieldVariant, "stacked"> | undefined => {
  if (variant === "stacked") {
    return "outlined"
  }

  return variant
}
